module.exports = __webpack_public_path__ + "img/Carton.feb3a5d2.png";